import React, { useCallback } from "react";
import { Input, Button, Form, Col, Row } from "reactstrap";
import EarningPartnerTable from "./EarningPartnerTable";
import { useParams } from "react-router-dom";

// Custom Hooks
import useTableController from "hooks/useTableController";

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

// API
import { useGetEarningLinksQuery, useLazyExportEarningLinksQuery } from "services/transactions/api";

// Icons
import { ReactComponent as XlsIcon } from "assets/icons/xls.svg";

// Utils
import { downloadFile, generateTimestampedFilename } from "utils/fileUtils";

const EarningPartnerTab = (v) => {
  const { id } = useParams();

  // HOOK CHANGE
  const { formik, searchInput, setSearchInput, handleTableChange } = useTableController({
    initialValues: {
      searchTerm: "",
    },
    validationSchema: SearchFilterSchema,
  });

  // API
  const { data, error, isLoading } = useGetEarningLinksQuery({ id, ...formik.values });
  const [exports] = useLazyExportEarningLinksQuery();

  // ACTIONS
  const onExport = async () => {
    try {
      const response = await exports({ id, ...formik.values });
      const fileName = generateTimestampedFilename("transections-earnings-links");
      await downloadFile(response.data, fileName);
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  // RENDER
  const renderTitleText = useCallback(() => {
    if (!v.data || !v.data.commission) {
      return "รายการธุรกรรมของพาร์ทเนอร์";
    }

    // const month = MONTH.find((m) => m.key === v.data.commission.commissionMonth)?.label;
    const month = "ธันวาคม";
    const year = new Date(v.data.commission.paymentDate).getFullYear() + 543;
    return ` รายการธุรกรรมของพาร์ทเนอร์ประจำเดือน${month} ${year}`;
  }, [v]);
  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className="affiliate-container" data-testid="tab-affiliate">
        <div className="header mt-4">
          <h2 className="fw-semibold">{renderTitleText()}</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={12} md={4} lg={4}>
                <div className="input-group-icon">
                  <i className="bx bx-search" />
                  <Input name="searchTerm" type="text" placeholder="ค้นหารายการธุรกรรม" onChange={(e) => setSearchInput(e.target.value)} value={searchInput} invalid={formik.touched.searchTerm && formik.errors.searchTerm} data-testid="search-input" />
                  {formik.touched.searchTerm && formik.errors.searchTerm && (
                    <div className="error-message" data-testid="search-error">
                      {formik.errors.searchTerm}
                    </div>
                  )}
                </div>
              </Col>
              <Col sm={12} md={8} lg={{ offset: 1, size: 7 }}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1"></div>

                  <Button color="success" size="xs" onClick={onExport} className="d-flex gap-2" data-testid="export-button">
                    <XlsIcon />
                    EXPORT EXCEL
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <EarningPartnerTable data={data} error={error} isLoading={isLoading} onTableChange={handleTableChange} />
      </div>
    </Form>
  );
};

export default EarningPartnerTab;
